// extracted by mini-css-extract-plugin
module.exports = {"linhaFlex":"detalhes-processo_linhaFlex__26sYw"};